import { render, staticRenderFns } from "./DispensaEdital.vue?vue&type=template&id=634d0066&scoped=true&"
import script from "./DispensaEdital.vue?vue&type=script&lang=js&"
export * from "./DispensaEdital.vue?vue&type=script&lang=js&"
import style0 from "./DispensaEdital.vue?vue&type=style&index=0&id=634d0066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d0066",
  null
  
)

export default component.exports